// Session recordings are video (usability sessions) or audio-only
// (interviews). Both go through the same upload and analysis pipeline; the
// backend checks the streams itself, so these helpers only decide what the
// page lets through and how it labels a recording.

// The file picker filter. Extensions next to the wildcards because some
// browsers leave audio/video types off for less common formats.
export const RECORDING_ACCEPT =
  "video/*,audio/*,.mp4,.m4v,.mov,.mp3,.m4a,.wav,.aac,.ogg,.opus,.flac,.webm";

// Fallback content types for files the browser gave no (useful) type.
const TYPES_BY_EXTENSION = {
  mp4: "video/mp4",
  m4v: "video/x-m4v",
  mov: "video/quicktime",
  webm: "video/webm",
  mp3: "audio/mpeg",
  m4a: "audio/mp4",
  wav: "audio/wav",
  aac: "audio/aac",
  ogg: "audio/ogg",
  opus: "audio/ogg",
  flac: "audio/flac",
};

function isMediaType(type) {
  return (
    typeof type === "string" &&
    (type.startsWith("video/") || type.startsWith("audio/"))
  );
}

// The content type to upload a file with, or null when it isn't a recording.
export function recordingContentType(file) {
  if (!file) return null;
  if (isMediaType(file.type)) return file.type;
  const ext = String(file.name || "")
    .split(".")
    .pop()
    .toLowerCase();
  return TYPES_BY_EXTENSION[ext] || null;
}

export function isAudioRecording(rec) {
  return String(rec?.contentType || "").startsWith("audio/");
}

// Short format label for the table, e.g. "MP4", "M4A", "MP3".
export function mediaLabel(contentType) {
  if (!contentType) return "FILE";
  const [type, sub = ""] = contentType
    .toLowerCase()
    .split(";")[0]
    .trim()
    .split("/");
  const clean = sub.replace(/^(x-|vnd\.)/, "");
  if (type === "audio") {
    if (clean === "mpeg" || clean === "mp3") return "MP3";
    if (clean === "mp4" || clean === "m4a") return "M4A";
    if (clean === "wave") return "WAV";
  }
  if (type === "video" && clean === "quicktime") return "MOV";
  return (clean || type).toUpperCase();
}
